import React from 'react';
import { useHistory } from 'react-router-dom';

import { Select } from '@magoosh/lib/forms';
import { paths } from 'config/path_helpers';

import { Metric } from '@magoosh/lib/contentful_contents/types';
import { SchoolProfileCategory } from '@schools/app/types';

interface Props {
  category: SchoolProfileCategory;
  currentMetric: Metric;
  metrics: Metric[];
  preview: boolean;
}

const MetricsSelect: React.FC<Props> = (props) => {
  const history = useHistory();

  const handleChange = (e) => {
    if (e.target.value != '') history.push(e.target.value);
  };

  return (
    <Select onChange={handleChange}>
      <option className="text-gray-light" value="">Choose a metric to view</option>
      {
        (props.metrics || []).map((metric, idx) => (
          <option
            key={idx}
            selected={metric.slug === props.currentMetric?.slug}
            value={paths.admissions.schoolProfileCategoryMetric(metric.slug, props.category?.slug, props.preview)}
          >
            {metric.name}
          </option>
        ))
      }
    </Select>
  )
};

export default MetricsSelect;
